var map = {
	"./busd.svg": 1989,
	"./crypto-pending.png": 1990,
	"./crypto-reject.png": 1991,
	"./crypto-success.png": 1992,
	"./direpay.svg": 1993,
	"./trx.svg": 1994,
	"./usdc.svg": 1995,
	"./usdt.svg": 1996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;